import { useCallback, useEffect } from 'react';

import { TimelinePublicApi } from '@bringg-frontend/bringg-timeline';
import { ScrollEvent, notifyNeedToScroll, scrollEmitter } from '@bringg-frontend/monitoring-shared';

export const useBringgTimelineScroll = (bringgTimelineApiRef: React.MutableRefObject<TimelinePublicApi>) => {
	useEffect(() => {
		const scroll = ({ scrollTop, target }: ScrollEvent) => {
			if (target === 'timeline') {
				return;
			}

			bringgTimelineApiRef.current?.scrollTo(scrollTop);
		};
		// Add timeline scroll at the start of the listeners to make sure it will be called first as it takes the longest,
		// so we would avoid flickering
		scrollEmitter.on(scroll, { addToStart: true });

		return () => {
			scrollEmitter.off(scroll);
		};
	}, [bringgTimelineApiRef]);

	const onTimelineScroll = useCallback((scrollTop: number) => {
		notifyNeedToScroll({ target: 'timeline', scrollTop, immediate: true });
	}, []);

	return onTimelineScroll;
};
